export default __webpack_public_path__ + "static/media/flagbase.9cccb703.png";